import React from 'react'
import Sketch from 'react-p5'
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title:"rotation",
        description:"characters rotate into infinity"
    },
    de: {
        title:"rotation",
        description:"zeichen rotieren sich in die unendlichkeit"
    }
});

class Rotate extends React.Component {
    constructor(props) {
        super(props)

        this.fontSize = 900;
        this.angle = 0;
        this.str = "";
        this.fontFact = 0.995
        this.angleInc = 0.1

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        p5.background(0)

        p5.textFont("DejaVuSerif");

        this.fontSize = window.innerHeight
		this.angle = 0
		this.str = p5.random(["z", "ä", "o", "m", "y", "p", "q", "g", "t", "j", "k", "ü", "?", "!", "ö", "r", "m", "n", "c", "x"])
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.reset(p5)
    }

    draw(p5) {
        var context = p5.drawingContext; // or p5.drawingContext
        context.shadowOffsetX = 0 //fontSize/20;
        context.shadowOffsetY = 0 //fontSize/20;
        context.shadowBlur = this.fontSize/20;
        context.shadowColor = '#000';

        p5.push()
        p5.translate(p5.width/2, p5.height/2)
        p5.rotate(this.angle)
        p5.textSize(this.fontSize)
        p5.fill(255, 255, 255, 255)
        p5.text(this.str, 0,0)
        p5.pop()

        this.fontSize = this.fontSize * this.fontFact
        this.angle = this.angle + this.angleInc
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Rotate.contextType = LanguageContext

export default Rotate
